import { type RepairType as UBIFRepairType } from '@service-initiation/shared-clients-tech-care-services';

import { type RepairType } from '../types/RepairType';

export const ubifRepairTypeToTechCareRepairType = (
  ubifRepairType: UBIFRepairType
): RepairType => ({
  class: ubifRepairType.class,
  id: ubifRepairType.id,
  name: ubifRepairType.name.us_en,
  sortOrder: ubifRepairType.sort_order,
  symptom: ubifRepairType.symptom.us_en,
  symptomImageUrl: ubifRepairType.symptom_image_url,
});
